export default "/images/vendor/@coreui/icons/svg/flag/cif-ve.svg?1f8cfa0eaad5517294bb3a9b18f12049";